export default {"src":"/_next/static/media/ion_close.5b48976f.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};